import React from "react";
import ProfileForm from "../../forms/account/ProfileForm";
import EditCustomerContainer from "../../containers/customers/EditCustomerContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Edit = ({ handleClose, open, profile }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("register.title_edit_profile")}
    >
      {profile ? (
        <EditCustomerContainer customer={profile}>
          {({ onSubmit, customer }) => (
            <ProfileForm onSubmit={onSubmit} initialValues={customer} />
          )}
        </EditCustomerContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
